import React, { useState } from "react";
import { TooltipButton } from "@/components/common/TooltipButton";
import { railGlyphPath, useGlyphMorph } from "./glyphMorph";

const MS_PER_STEP = 320;

interface RailToggleProps {
  isOpen: boolean;
  onToggle: () => void;
}

/// Hovered while open, the logo folds into a triangle pointing left; closing
/// the rail turns it to point right (`.rail-toggle--closed`).
export const RailToggle: React.FC<RailToggleProps> = ({ isOpen, onToggle }) => {
  const [hovered, setHovered] = useState(false);
  // An expand click leaves the pointer on the toggle; the logo comes back anyway.
  const [held, setHeld] = useState(false);
  const pathRef = useGlyphMorph(
    !isOpen || (hovered && !held) ? 2 : 0,
    railGlyphPath,
    MS_PER_STEP,
  );
  const labelFor = (open: boolean) => (open ? "Collapse menu" : "Expand menu");
  // The words and side the tooltip opened with, kept through the click that flips them.
  const [tipFor, setTipFor] = useState(isOpen);
  const leave = () => {
    setHovered(false);
    setHeld(false);
  };
  return (
    <TooltipButton
      title={labelFor(tipFor)}
      aria-label={labelFor(isOpen)}
      // Open, the mycorr.app link slides in where a right-hand tooltip sits.
      placement={tipFor ? "bottom" : "right"}
      onClick={() => {
        setHeld(!isOpen);
        onToggle();
      }}
      onPointerEnter={() => {
        setHovered(true);
        setTipFor(isOpen);
      }}
      onPointerLeave={leave}
      onFocus={(e) => {
        setHovered(e.currentTarget.matches(":focus-visible"));
        setTipFor(isOpen);
      }}
      onBlur={leave}
      variant="default"
      size="md"
      className={`logo-button rail-toggle${isOpen ? "" : " rail-toggle--closed"}`}
    >
      <svg viewBox="0 0 48 48" className="rail-toggle__glyph" aria-hidden>
        <path
          ref={pathRef}
          fill="none"
          stroke="currentColor"
          strokeWidth={4}
          strokeLinejoin="bevel"
        />
      </svg>
    </TooltipButton>
  );
};
